export interface Risc0Proof {
  proof: string;
  version: string;
}

export interface Risc0Vk {
  vk: string;
}

export interface Risc0Pubs {
  pubs: string;
}
